export default {
  menu: 'Menü',
  wineList: 'Weinkarte',
  locale: 'Wählen Sie Ihre Sprache<br/> um auf das Menü zuzugreifen:',
  claim:
    'Von der Terrasse,<br/> erzählt jedes Gericht eine Geschichte,<br/> jeder Blick entdeckt den Horizont.',
  claimWine: 'Eine Terrasse voller Geschichte,<br /> ein Toast auf das Land.',
  appetizer: 'Aufschnitt, Käse und mehr',
  'hot-dishes': 'Warme Gerichte',
  'fish-dishes': 'Aromen des Meeres',
  dessert: 'Süße Abschlüsse',
  drinks: 'Zu trinken und zu genießen',
  cocktail: 'Alchemie im Glas',
  coffee: 'Kaffeemoment',
  spirits: 'Destillierte Essenz',
  beer: 'Malz und Hopfen im Fest',
  bollicine: 'Valdobbiadene DOCG & CO',
  altreBollicine: 'Andere lokale Schaumweine',
  champagne: 'Klassische Methode und Champagner',
  viniBianchi: 'Weißweine',
  viniRossi: 'Rotweine',
  glass: 'Glas',
  bottle: 'Flasche',
  takeAway: 'Zum Mitnehmen',
  social: 'Folgen Sie uns auf',
  service: 'Gedeck €2',
  info: 'Für Informationen zu Allergenen und Unverträglichkeiten wenden Sie sich bitte an das Personal.<br/> Einige Produkte können tiefgekühlt sein.',
  time: 'Öffnungszeiten',
  contacts: 'Kontakte',
  directions: 'Anfahrt',
  monday: 'Montag',
  tuesday: 'Dienstag',
  wednesday: 'Mittwoch',
  thursday: 'Donnerstag',
  friday: 'Freitag',
  saturday: 'Samstag',
  sunday: 'Sonntag',
  close: 'Geschlossen',
  contact: 'Kontakte',
}
